import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Policy } from "gql/graphql";

export type AssessmentPrivacyPolicyState = {
  privacyPolicyType?: Policy;
  error?: string;
};

const initialState: AssessmentPrivacyPolicyState = {};

const assessmentPrivacyPolicySlice = createSlice({
  name: "assessmentPrivacyPolicy",
  initialState,
  reducers: {
    setAssessmentPrivacyPolicy(
      state,
      action: PayloadAction<AssessmentPrivacyPolicyState>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setAssessmentPrivacyPolicyError(state, action: PayloadAction<string>) {
      return {
        ...state,
        error: action.payload,
      };
    },
  },
});

export const { setAssessmentPrivacyPolicy, setAssessmentPrivacyPolicyError } =
  assessmentPrivacyPolicySlice.actions;

export default assessmentPrivacyPolicySlice;
